import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  className?: string;
}
export function PriceDisplay({
  amount,
  className = ''
}: PriceDisplayProps) {
  const [formattedPrice, setFormattedPrice] = useState(`$${amount.toLocaleString('es-AR')}`);
  useEffect(() => {
    const locale = navigator.language || 'es-AR';
    let currency = 'ARS';
    if (locale.startsWith('en-GB')) currency = 'GBP';else if (locale.startsWith('en')) currency = 'USD';else if (['es-ES', 'fr', 'de', 'it', 'pt', 'nl'].some(l => locale.startsWith(l))) currency = 'EUR';else if (['es-AR', 'es-419', 'es-MX', 'es-CL', 'es-CO'].some(l => locale.startsWith(l))) currency = 'ARS';
    try {
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      });
      setFormattedPrice(formatter.format(amount));
    } catch (e) {
      // Fallback if formatting fails
      setFormattedPrice(`$${amount.toLocaleString()}`);
    }
  }, [amount]);
  return <span className={className} data-id="element-204">{formattedPrice}</span>;
}